import { ICountry } from '../interface';

export const FORD_COUNTRIES: ICountry[] = [
  {
    id: 57,
    name: 'Deutschland (DE)',
    isoCode: 'DEU',
    defaultLanguage: {
      name: 'German',
      isoCode: 'DEU'
    }
  },  
  {
    id: 68,
    name: 'Spain (ES)',
    isoCode: 'ESP',
    defaultLanguage: {
      name: 'Spanish',
      isoCode: 'SPA'
    }
  },
  {
    id: 75,
    name: 'France (FR)',
    isoCode: 'FRA',
    defaultLanguage: {
      name: 'French',
      isoCode: 'FRA'
    }
  },
  {
    id: 77,
    name: 'UK - Great Britain (EN)',
    isoCode: 'GBR',
    defaultLanguage: {
      name: 'English',
      isoCode: 'ENG'
    }
  },  
  {
    id: 250,
    name: 'UK - Northern Ireland (EN)',
    isoCode: 'GBR',
    defaultLanguage: {
      name: 'English',
      isoCode: 'ENG'
    }
  },
  {
    id: 110,
    name: 'Italy (IT)',
    isoCode: 'ITA',
    defaultLanguage: {
      name: 'Italian',
      isoCode: 'ITA'
    }
  },
  {
    id: 184,
    name: 'Portugal (PT)',
    isoCode: 'PRT',
    defaultLanguage: {
      name: 'Portuguese',
      isoCode: 'PRT'
    }
  }
];

export enum Theme {
  light = 'light',
  dark = 'dark'
}

export enum Variant {
  FORD = 'ford',
  BMW = 'bmw'
}

export const ENABLE_FORD_LICENSE_PLATE_COUNTRIES = ['GBR', 'ESP', 'FRA', 'PRT'];

export const FOOTER_LINKS: any = {
  GBR: {
    home: 'https://www.castrol.com/en_gb/united-kingdom/home/car-engine-oil-and-fluids/motor-oil-and-fluids-finder.html',
    contact: 'https://www.castrol.com/en_gb/united-kingdom/home/castrol-story/contact-us.html',
    legal: 'https://www.castrol.com/en_gb/united-kingdom/home/legal-notice.html',
    privacy: 'https://www.castrol.com/en_gb/united-kingdom/home/privacy-statement.html'
  },
  ESP: {
    home: 'https://www.castrol.com/es_es/spain/home/car-engine-oil-and-fluids/motor-oil-and-fluids-finder.html',
    contact: 'https://www.castrol.com/es_es/spain/home/castrol-story/contact-us.html',
    legal: 'https://www.castrol.com/es_es/spain/home/legal-notice.html',
    privacy: 'https://www.castrol.com/es_es/spain/home/privacy-statement.html'
  },
  DEU: {
    home: 'https://www.castrol.com/de_de/germany/home/car-engine-oil-and-fluids/motor-oil-and-fluids-finder.html',
    contact: 'https://www.castrol.com/de_de/germany/home/castrol-story/contact-us.html',
    legal: 'https://www.castrol.com/de_de/germany/home/legal-notice.html',
    privacy: 'https://www.castrol.com/de_de/germany/home/privacy-statement.html'
  },
  FRA: {
    home: 'https://www.castrol.com/fr_fr/france/home/car-engine-oil-and-fluids/motor-oil-and-fluids-finder.html',
    contact: 'https://www.castrol.com/fr_fr/france/home/castrol-story/contact-us.html',
    legal: 'https://www.castrol.com/fr_fr/france/home/legal-notice.html',
    privacy: 'https://www.castrol.com/fr_fr/france/home/privacy-statement.html'
  },
  ITA: {
    home: 'https://www.castrol.com/it_it/italy/home/product-finder.html',
    contact: 'https://www.castrol.com/it_it/italy/home/about-castrol/contact-us.html',
    legal: 'https://www.castrol.com/it_it/italy/home/legal-notice.html',
    privacy: 'https://www.castrol.com/it_it/italy/home/privacy-statement.html'
  },
  PRT: {
    home: 'https://www.castrol.com/pt_pt/portugal/home/car-engine-oil-and-fluids/motor-oil-and-fluids-finder.html',
    contact: 'https://www.castrol.com/pt_pt/portugal/home/castrol-story/contact-us.html',
    legal: 'https://www.castrol.com/pt_pt/portugal/home/legal-notice.html',
    privacy: 'https://www.castrol.com/pt_pt/portugal/home/privacy-statement.html'
  }
}
